
import React, { useEffect, useRef, useState } from "react";
import { Dropdown , Tab } from 'react-bootstrap'
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { expensePolicyLockingExpenseInitialsForUpdate } from "./interfaces/expensePolicyLockingExpenseClass";
import { getDataForlockingExpenseByAccountExpensePolicyIdAsync,getDataLockExpensesForEditByAccountExpensePolicyIdAsync, resetSelectedRecordObjectInState } from "./expensePolicyLockingExpensesSlice";
import { Link, useLocation } from 'react-router-dom';
import { json } from "stream/consumers";
import ExpensePolicyLockingExpensesForm from "./ExpensePolicyLockingExpensesForm";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import ExpensePolicyRuleOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { ShowToast } from "../../../common/Toastr";
import ExpensePolicyLockOffCanvas from '../../../common/OffCanvas';
import { useTranslation } from "react-i18next";
import Loader from '../../../common/Loader';
import { useNavigate } from 'react-router-dom';
import clsx from "clsx";
import { getValueFromResource } from "../../../common/timeLiveFunction";
const itemClass = 'ms-1 ms-lg-0';

const ExpensePolicyLockingExpenses = (props : any) => {
    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const location = useLocation();
    const { t } = useTranslation();
    const [isLockExpenseModalOpen, setIsLockExpenseModalOpen] = useState<boolean>(false);
    const { expensePolicyLockingExpenseDetail,  isReload,isLoading, selectedRecord } = useAppSelector((state) => state.expensePolicyLockingExpenses);
    const { MasterExpensePolicyId} = useAppSelector((state) => state.expensePolicy);
    const navigate = useNavigate();
    const { obj } = location.state || {};
    const storedObjectData = localStorage.getItem('objExpensePolicyItem');
    const objectData = storedObjectData ? JSON.parse(storedObjectData) : null;
    let AccountExpensePolicyId = '00000000-0000-0000-0000-000000000000';
    if (MasterExpensePolicyId && MasterExpensePolicyId !== '') {
        AccountExpensePolicyId = MasterExpensePolicyId;
    } else if (obj && obj.AccountExpensePolicyId) {
        AccountExpensePolicyId = obj.AccountExpensePolicyId;
    } else if (objectData && objectData.AccountExpensePolicyId) {
        AccountExpensePolicyId = objectData.AccountExpensePolicyId;
    } else {
        navigate('../expensepolicy');
    }

    useEffect(() => {
        if (isReload) { 
            dispatch(getDataForlockingExpenseByAccountExpensePolicyIdAsync(AccountExpensePolicyId));
        }
    }, [isReload])

    useEffect(() => {
        dispatch(getDataForlockingExpenseByAccountExpensePolicyIdAsync(AccountExpensePolicyId)); 
    }, [dispatch])  
    const onEditClick = (AccountExpensePolicyId: string) => {
        openModalExpenseLock();       
    }

    const openModalExpenseLock = () => {
        setIsLockExpenseModalOpen(true);
    };

    const closeModalExpenseLock = () => {
        setIsLockExpenseModalOpen(false);
    };

 
    return (
        <>
               {isLoading && <Loader />}

        <div className="card card-custom admin-card">
        <div className="card-header card-drop sticky-top bg-white"  style={{marginLeft:'-10px'}} >
                 <h3 className="card-title fw-bold mainHeading" >
                    {/* {t('Locking Expense Entries')} */}
                    {getValueFromResource('Locking Expense Entries',dispatch, t)}

                    </h3>
                </div>
                {/* <div className="card-body"> */}
                <div className="card-Report-body">
                    <div className="table-responsive">
                    <table className="table table-row-bordered  align-middle gs-1 gy-1 gx-1" >
                <thead>
                    <tr className="thHeading align-middle " >                              
                    <th className='min-w-100%' style={{ textAlign: 'center' }}>
                        {/* {t('Lock All Previous Expense Entries')} */}
                        {getValueFromResource('Lock All Previous Expense Entries',dispatch, t)}
                        </th>
                    <th className='min-w-100%' style={{ textAlign: 'center' }}>
                        {/* {t('Lock All Previous Months Expense Entries')} */}
                        {getValueFromResource('Lock All Previous Months Expense Entries',dispatch, t)}

                        </th>
                                </tr>
                            </thead>
                            <tbody>
                    {expensePolicyLockingExpenseDetail && expensePolicyLockingExpenseDetail.length > 0  && (
                        <tr>
                         <td style={{ textAlign: 'center' }}>{expensePolicyLockingExpenseDetail[0].LockAllPreviousExpenseEntries == true ? 'Yes' : 'No'}</td>
                           <td style={{ textAlign: 'center' }}>{expensePolicyLockingExpenseDetail[0].LockAllPreviousMonthsExpenseEntries == true ? 'Yes' : 'No'}</td>
                           <td className='text-center' >
                           <Dropdown
                                    style={{ marginLeft: 1 }}
                                    className={clsx('cursor-pointer symbol')}
                                    data-kt-menu-attach='parent'
                                    data-kt-menu-placement='bottom-end'
                                >
                                    <Dropdown.Toggle
                                        variant="transparent"
                                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                        data-tooltip-id="tooltip-Description"
                                        data-tooltip-content=
                                        // {t("More")}
                                        {getValueFromResource('More',dispatch, t)}

                                        data-tooltip-place="top"
                                    >
                                        <i className="bi bi-three-dots fs-7"></i>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 px-1 py-1 fs-2 w-150px'>                                                  
                                                            <div className='menu-hover-bg-sec'>
                                                                <Dropdown.Item
                                                                    className="menu-item me-lg-0 "
                                                                    onClick={() => { onEditClick(expensePolicyLockingExpenseDetail[0].AccountExpensePolicyId) }} 
                                                                >
                                                                    <span className="menu-icon custom-menu">
                                                                        <i className="bi bi-pencil-square fs-6 iconColor allign">
                                                                            <span className="path1"></span>
                                                                            <span className="path2"></span>
                                                                        </i>
                                                                    </span>
                                                                    <span className="menu-title custom-menu-fontsize">
                                                                        {/* {`${t('Edit')}`} */}
                                                                        {getValueFromResource('Edit',dispatch, t)}

                                                                        </span>
                                                                </Dropdown.Item>
                                                            </div>                                                                                                                                                         
                                                </Dropdown.Menu>
                                            </Dropdown>
                            </td>
                            </tr>
                            )}
                            </tbody>
                        </table>
                    </div>
                </div>
            
        </div>
            {isLockExpenseModalOpen &&
                <ExpensePolicyLockingExpensesForm modelRef={modelRef} t={t} oncloseModal={closeModalExpenseLock}/>
            }
        </>
    )
}
export default ExpensePolicyLockingExpenses;